function UpdateNaicsList(evt, type) {
    var key = evt.id;
    $.DotComAjax({
        url: "/UsBusiness/NaicsCodeItemList?key=" + key + "&type=" + type,
        cache: true,
        success: function (data) {
            $('.NaicsItemList').html(data);
            if (typeof success == 'function') {
                success();
            }
        },
        error: function () {
            context.find('img').attr('src', '/Images/Common/Exclamation.gif').attr('alt', 'Could not remove this selection');
        },
        async: true
    });
}

function SelectNaicsItem(item) {
    var found = false;
    $("#SerializedNaicsCodes_TextBoxes input.TextBoxGridSels").each(function (index) {
        if ($(this).val() == '' && found == false) {
            $(this).val(item.id);
            SelectedTextBoxGridValues('#SerializedNaicsCodes_TextBoxes');
            found = true;
        }
    });
    if (found == false) {
        AddTextBoxesToGrid('#SerializedNaicsCodes_TextBoxes', "2", "5");
        SelectNaicsItem(item);
    }
}
